import React from 'react'
import { Container, FilterField, RepFields, SelectField, TextField } from '../Fields'
import { binaryFilterOptions, yesNoOptions } from './selectOptions'

export const CompanyView: React.VFC = () => {
    return (
        <Container>
            <TextField label="Seller" name="filters.company.seller" placeholder="Try 'GB Sales'" />
            <FilterField
                label="Seller ID"
                selectProps={{
                    name: 'filters.company.sellerIdOp',
                    options: binaryFilterOptions,
                }}
                textFieldProps={{
                    name: 'filters.company.sellerId',
                    placeholder: "Try 'C12345'",
                }}
            />
            <FilterField
                label="Seller Type"
                selectProps={{
                    name: 'filters.company.sellerTypeOp',
                    options: binaryFilterOptions,
                }}
                textFieldProps={{
                    name: 'filters.company.sellerType',
                    placeholder: "Try 'UC' or 'UC, NC'",
                }}
            />
            <TextField label="Buyer" name="filters.company.buyer" placeholder="Try 'GB Sales'" />
            <FilterField
                label="Buyer ID"
                selectProps={{
                    name: 'filters.company.buyerIdOp',
                    options: binaryFilterOptions,
                }}
                textFieldProps={{
                    name: 'filters.company.buyerId',
                    placeholder: "Try 'C12345'",
                }}
            />
            <FilterField
                label="Buyer Type"
                selectProps={{
                    name: 'filters.company.buyerTypeOp',
                    options: binaryFilterOptions,
                }}
                textFieldProps={{
                    name: 'filters.company.buyerType',
                    placeholder: "Try 'UC' or 'UC, NC'",
                }}
            />
            <RepFields />
            <SelectField label="My Favorites" name="filters.company.isFavorite" options={yesNoOptions} />
        </Container>
    )
}

export default CompanyView
